import React, { useRef, useState } from "react";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../Components/BaseUrl";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const Onboardingstep3 = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const validateForm = () => {
    let isValid = true;
    if (otp.join("").length !== 6) {
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = validateForm();
    const user_id = Cookies.get("user_id");
    const requestdata = {
      otp: otp.join(""),
    };
    console.log(requestdata);
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + "onboarding/step3",
          requestdata,
          {
            headers: {
              "user-id": user_id,
            },
          }
        );
        console.log(response.data.status);
        if (response.data.status === 200) {
          setTimeout(() => {
            navigate("/user/onboarding/step4");
          }, 100);
        }
        else{
          Swal.fire({
            icon: "warning",
            title:response.data.message,
            confirmButtonText:"Done",
            showConfirmButton:true,
          })
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="flex flex-col items-center mt-12 justify-start min-h-screen bg-[#F3F2EF] py-16 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md text-center mb-4">
        <p className="text-3xl mb-2 ">Confirm your email</p>
        <p className="text-[16px] text-gray-500">
          Type in the code we sent to your registered email
        </p>
      </div>
      <form
        onSubmit={handleSubmit}
        className="space-y-4 flex flex-col items-center justify-center w-2/4"
      >
        <div className="flex space-x-2 mt-6 ">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              value={digit}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              ref={(el) => (inputRefs.current[index] = el)}
              maxLength="1"
              className="w-12 h-12 text-center text-xl border rounded focus:ring-2 focus:ring-blue-500 outline-none"
            />
          ))}
        </div>
        <div className=" flex mt-6 border border-gray-300 p-4 rounded-lg w-3/4 gap-2">
          <div className="">
            <VerifiedUserOutlinedIcon className="text-blue-500 text-2xl" />
          </div>
          <div>
            <p className="text-[16px] font-medium">Your privacy is important</p>
            <p className="text-[12px] text-gray-500 ">
              we may send you member updates, recuriter message, job
              suggesstions, invitations, reminders and promotional messages from
              us nad our partners. ypu can change your preferences at anytime.
            </p>
          </div>
        </div>
        <div>
          <p className="text-[16px] font-medium">
            Didn't recieve the code?{"  "}
            <span className=" text-[14px] text-gray-500 font-semibold ml-4">
              Send again
            </span>
          </p>
        </div>
        <button
          type="submit"
          className="w-3/4 bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-400"
          disabled={otp.join("").length !== 6}
        >
          Agree & Confirm
        </button>
      </form>
    </div>
  );
};
export default Onboardingstep3;
